module.exports = __webpack_public_path__ + "media/images/homes/refunds_returns2x-13af2e3f56d669c8715b47db6b3f152c.png";